import React from 'react';
import PropTypes from 'prop-types';
import InlineFormField from 'wonderbly-components/lib/InlineFormField';
import Tooltip from 'wonderbly-components/lib/Tooltip';

const Name = props => (
  <div className="name">
    <Tooltip className="error-tooltip" visible={!!props.error} absolute={!props.tabletDown} type="alert">
      {props.error}
    </Tooltip>
    <InlineFormField
      id={props.id}
      label={props.label}
      fieldType="input"
      value={props.name}
      onChange={props.onHandleChange}
    />
  </div>
);

Name.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onHandleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  tabletDown: PropTypes.bool
};

export default Name;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Adventurer/Name/Name.js